import BetBuilderMarketModel from './betbuilder-market-model';
import BetBuilderTabModel from './betbuilder-tab-model';

export default class BetBuilderTabsModel {
    /**
     * class constructor method
     * @param {any[]} data
     */
    constructor(data) {
        /**
         * @type {{[x:string]: BetBuilderTabModel}}
         */
        let tabs = {};
        data.forEach((p) => {
            if (!tabs[p.Category]) {
                tabs[p.Category] = new BetBuilderTabModel(p);
            }
            tabs[p.Category].markets.push(new BetBuilderMarketModel(p));
        });
        this.tabs = tabs;
    }
}
